import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigationColor: 'black',
    backgroundColor: 'white',
    logoColor: 'black',
    isFirstPage: true,
    isMenuBurgerVisible: true,
  },
  getters: {
    navigationColor: state => state.navigationColor,
    backgroundColor: state => state.backgroundColor,
    logoColor: state => state.logoColor,
    isFirstPage: state => state.isFirstPage,
    isMenuBurgerVisible: state => state.isMenuBurgerVisible,
  },
  mutations: {
    setNavigationColor ( state, color ) {
      state.navigationColor = color
    },
    setBackgroundColor ( state, color ) {
      state.backgroundColor = color
    },
    setLogoColor ( state, color ) {
      state.logoColor = color
    },
    setFirstPage ( state ) {
      state.isFirstPage = false
    },
    setMenuBurger ( state, isVisible ) {
      state.isMenuBurgerVisible = isVisible
    },
  },
  actions: {

  },
})
